module.exports = __webpack_public_path__ + "static/media/skiing.6f792abe.mp4";